/**
 * ANWENDERTEXTE DER KOPFLEISTE, soweit sie mit den Entscheiden 677 und 679 dazugekommen sind (Handbuch-Knopf). Die
 * Bereichsnamen kommen aus den Einträgen der Navigation (Navigation.tsx), nicht von hier.
 */
export const HEADER_TEXT = {
  /** Sofort-Popup und zugänglicher Name des Handbuch-Knopfs (677). */
  manual: (area: string): string => `Handbuch zu ${area}`,
  /** Dasselbe für eine Adresse ohne Bereich (unbekannte Seite): Der Knopf führt auf die Startseite des Handbuchs. */
  manualHome: "Handbuch",
  /** Name und Sofort-Popup der Lupe (noch abgeschaltet, die übergreifende Suche kommt mit einem späteren Paket). */
  search: "Suche",
  /** Name und Sofort-Popup des Zahnrads und seines Menüs. */
  settings: "Anwendung einrichten",
} as const;

/**
 * Der Name des EINEN Handbuchfensters (Dirk 03.11.2026): Der Handbuch-Knopf öffnet das Handbuch darin oder holt es nach
 * vorn, statt je Klick ein neues Fenster zu öffnen oder die Anwendung zu ersetzen. Kein Anwendertext — er steht hier
 * neben den Texten der Kopfleiste, damit er nicht im JSX steht.
 */
export const MANUAL_WINDOW_NAME = "kundeninfo-handbuch";
/** Ein per window.open geöffnetes Handbuchfenster, das nach dieser Zeit noch leer ist (about:blank), hat Safari an die
 * Handbuch-Web-App übergeben — es wird geschlossen (Kopfzeile.tsx, Dirk 03.11.2026). Geprüft alle MANUAL_WINDOW_POLL_MS. */
export const MANUAL_WINDOW_BLANK_MS = 1500;
export const MANUAL_WINDOW_POLL_MS = 100;
